import type {BioIconProps} from '../common-types'

export function ArrowIcon({fill = 'white', strokeWidth = '1.06277', ...attributes}: BioIconProps) {
  return (
    <svg width="11" height="9" viewBox="0 0 11 9" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
      <path
        d="M6.37649 0.531387L10.0962 4.25109M10.0962 4.25109L6.37649 7.97078M10.0962 4.25109H0.53125"
        stroke={fill}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
